import React, { useContext, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, Card, Chip, FormControl, FormControlLabel, FormLabel, Grid, IconButton, MenuItem, Modal, Radio, RadioGroup, Select, Stack, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Add, ArrowBack } from '@mui/icons-material';
import { useForm ,Controller, FormProvider, set, useFormContext} from 'react-hook-form';

import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { Helpers } from '../../../services/Helpers';
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BannerDataContext } from './AddEditBanner';
import ImgUploadDialog from '../../../components/ImgUpload/imgUpload';

const ImageSection = () => {
    const {bannerData,imageUploadResponseDetails,setImageUploadResponseDetails,isSubmitting,onSubmit} = useContext(BannerDataContext);
    const {control,watch,handleSubmit,setValue,formState:{isDirty,errors,dirtyFields },reset}= useFormContext();

    const width = watch('width');
    const height = watch('height');
    const aspectRatio = watch('aspectRatio');
     /*================== image upload realted ====================== */
    const [imgModalOpen, setImgModalOpen] = useState(false);
    
        const openImgModal = () => {
            setImgModalOpen(true);
        };
    
        const closeModal = () => {
            setImgModalOpen(false);
            // afterAddPop(1);
        };
        
        const imgData = {
            path: 'banner/home/slider',
            img_type: "single"
        };
        const imgUploadResponse = (data) => {
           
            // "data": {
            //     "imageBaseUrl": "https://cudel.s3.amazonaws.com/",
            //     "imageDirectory": "staging/banner/home/slider/",
            //     "imageName": "screenshot-2025-01-08-094713-1739079273673.png"
            // }
            setImageUploadResponseDetails(data);
            setValue('imageUrl', data.imageDirectory+data.imageName, { shouldDirty: true,shouldValidate: true });
        }
  return (
    <>
        <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ p: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>
                    Banner Image <Box component="span" sx={{ color: 'error.main' }}>*</Box>
                </Typography>
                
                <Box sx={{ mb: 2, textAlign: 'center' }}>
                    {(imageUploadResponseDetails.imageName || bannerData.imageUrl) && (
                        <Box sx={{ mb: 2, justifyContent: 'center',boxShadow: '0 0 5px rgba(0,0,0,0.1)' }}>
                            <img
                                src={`${process.env.REACT_APP_IMAGE_STORE_PATH}/${imageUploadResponseDetails.imageDirectory+imageUploadResponseDetails.imageName || bannerData.imageUrl}`}
                                alt="Service"
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                        </Box>
                    )}
                    
                    <Button 
                        onClick={openImgModal}
                        disabled={!width || !height || isSubmitting}
                        variant="outlined"
                        startIcon={<AddToPhotosIcon />}
                        size="small"
                        fullWidth
                    >
                        {imageUploadResponseDetails.imageName || bannerData.imageUrl ? 'Change Image' : 'Upload Image'}
                    </Button>
                </Box>

                <Controller
                    control={control}
                    name='imageUrl'
                    rules={{ required: 'Please upload an image' }}
                    render={({ fieldState: { error } }) => (
                        error && (
                            <Typography color="error" variant="caption" display="block" textAlign="center">
                                {error.message}
                            </Typography>
                        )
                    )}
                />

                <Box sx={{ mt: 3, textAlign: 'center' }}>
                    <Button 
                        disabled={!isDirty || isSubmitting}
                        onClick={handleSubmit(onSubmit)}
                        // type='submit'
                        variant="contained"
                        color="primary"
                        size='small'
                        fullWidth
                    >
                        {bannerData.id>0 ? 'Update':'Save'}
                    </Button>
                </Box>
            </Card>
        </Grid>

        {/* ============== image upload dialog ============= */}
        <ImgUploadDialog
            open={imgModalOpen} 
            onClose={closeModal} 
            imgData={imgData} 
            imgUploadResponse={imgUploadResponse}
            maxFileSize={1*1024*1024} // 1 MB
            // Dimension validation - both values required if used
            expectedWidth={width}
            expectedHeight={height}
            // OR use aspect ratio validation (can be used with or without dimensions)
            expectedAspectRatio={aspectRatio}
            // Optional customization of tolerance
            dimensionTolerance={0} // Allow 10px difference in dimensions
            aspectRatioTolerance={0} // Allow more flexibility in aspect ratio 
        />
    </>
  );
}

export default ImageSection;
